(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["amu-cart-quiz-block"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.amu-cart-quiz').forEach(function(section){
      var statusEl = section.querySelector('[id^="amu-cq-status-"]');
      var saveTimer = null;

      function setStatus(text){
        if (!statusEl) return;
        statusEl.textContent = text;
        if (text) {
          clearTimeout(saveTimer);
          saveTimer = setTimeout(function(){ statusEl.textContent = ''; }, 2500);
        }
      }

      function saveAttribute(key, value){
        setStatus('Zapisywanie…');
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { [key]: value } })
        })
          .then(function(res){ return res.json(); })
          .then(function(){ setStatus('Zapisano ✓'); })
          .catch(function(){ setStatus('Nie udało się zapisać — spróbuj ponownie'); });
      }

      section.querySelectorAll('.amu-pill').forEach(function(btn){
        btn.addEventListener('click', function(){
          var key = btn.dataset.key;
          var value = btn.dataset.value;
          var group = btn.closest('.amu-q-pills');
          group.querySelectorAll('.amu-pill').forEach(function(b){ b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          saveAttribute(key, value);
        });
      });

      // --- Faktura VAT: checkbox rozwijający pole NIP ---
      var invoiceToggle = section.querySelector('.amu-invoice-check input[type="checkbox"]');
      var invoiceField = section.querySelector('.amu-invoice-field');
      var nipInput = section.querySelector('.amu-nip-input');
      var nipTimer = null;

      // Zapisuje jednocześnie do atrybutu koszyka (ładny widok w adminie Shopify)
      // ORAZ do notatki zamówienia (note) - to pole faktycznie synchronizuje się
      // z Base/BaseLinker jako "Uwagi", w przeciwieństwie do samych atrybutów.
      function saveInvoiceData(checked, nip){
        var nipDisplay = nip ? nip : '(nie podano)';
        var noteText = checked ? ('Faktura VAT: Tak, NIP: ' + nipDisplay) : '';

        setStatus('Zapisywanie…');
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            note: noteText,
            attributes: {
              'Faktura VAT': checked ? 'Tak' : 'Nie',
              'NIP': checked ? nip : ''
            }
          })
        })
          .then(function(res){ return res.json(); })
          .then(function(){ setStatus('Zapisano ✓'); })
          .catch(function(){ setStatus('Nie udało się zapisać — spróbuj ponownie'); });
      }

      if (invoiceToggle && invoiceField) {
        invoiceToggle.addEventListener('change', function(){
          if (invoiceToggle.checked) {
            invoiceField.classList.add('is-open');
            nipInput.focus();
            saveInvoiceData(true, nipInput.value.trim());
          } else {
            invoiceField.classList.remove('is-open');
            nipInput.value = '';
            saveInvoiceData(false, '');
          }
        });
      }

      if (nipInput) {
        nipInput.addEventListener('input', function(){
          clearTimeout(nipTimer);
          nipTimer = setTimeout(function(){
            saveInvoiceData(invoiceToggle.checked, nipInput.value.trim());
          }, 600);
        });
        nipInput.addEventListener('blur', function(){
          clearTimeout(nipTimer);
          saveInvoiceData(invoiceToggle.checked, nipInput.value.trim());
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
